"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.labelStyles = void 0;
var tslib_1 = require("tslib");
var emotion_1 = require("emotion");
var appStylesBase_1 = require("./appStylesBase");
var labelStyles = function () { return (0, emotion_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-bottom: ", ";\n  color: ", ";\n  font-size: ", ";\n  &:first-letter {\n    text-transform: capitalize;\n  }\n"], ["\n  margin-bottom: ", ";\n  color: ", ";\n  font-size: ", ";\n  &:first-letter {\n    text-transform: capitalize;\n  }\n"])), (0, appStylesBase_1.appStylesBase)().spacing.small, (0, appStylesBase_1.appStylesBase)().textColor.primary.light, (0, appStylesBase_1.appStylesBase)().fontSizes.small); };
exports.labelStyles = labelStyles;
var templateObject_1;
